import _api from '../../logisticOperators/_api';

import LogisticOperator from '../../../models/LogisticOperator';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    actual: {},
  },
  // -----------------------------------------------------------------
  getters: {
    actual: (state,) => state.actual,
  },
  // -----------------------------------------------------------------
  mutations: {
    newLogisticOperator (state,) {
      state.actual = new LogisticOperator();
    },
    setLogisticOperator (state, logisticOperator,) {
      state.actual.logisticOperator = logisticOperator;
    },
    setLogisticOperatorStores (state, stores,) {
      state.actual.stores = stores;
    },
    setLogisticOperatorDrivers (state, drivers,) {
      state.actual.drivers = drivers;
    },
    setLogisticOperatorAttachments (state, attachments,) {
      state.actual.attachments = attachments;
    },
    cleanLogisticOperator (state,) {
      state.actual = {};
    },
  },
  // -----------------------------------------------------------------
  actions: {
    getLogisticOperatorDetails ({ commit, }, logisticOperatorID,) {
      commit('cleanLogisticOperator',);
      commit('newLogisticOperator',);

      _api.get({ _id: logisticOperatorID, },).then(
        (response,) => {
          commit('setLogisticOperator', response.data,);
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );

      _api.getLogisticOperatorStores({ _id: logisticOperatorID, },).then(
        (response,) => {
          commit('setLogisticOperatorStores', response.data,);
        },
        () => {
          commit('setLogisticOperatorStores', {
            total_count: 0,
            items: [],
          },);
        },
      );

      _api.getLogisticOperatorDrivers({ _id: logisticOperatorID, },).then(
        (response,) => {
          commit('setLogisticOperatorDrivers', response.data,);
        },
        () => {
          commit('setLogisticOperatorDrivers', {
            total_count: 0,
            items: [],
          },);
        },
      );
    },
    updateLogisticOperator ({ getters, }, valuesToUpdate,) {
      return _api.patch(getters.actual._id, valuesToUpdate,);
    },
    setLogisticOperator ({ commit, }, logisticOperator,) {
      return commit('setLogisticOperator', logisticOperator,);
    },
    addLogisticOperatorAttachment ({ getters, }, valuesToUpdate,) {
      // return commit('setLogisticOperatorAttachments', valuesToUpdate);
      const attachmentPromises = [];
      valuesToUpdate.forEach((attachment,) => {
        attachmentPromises.push(
          _api.postAttachment(getters.actual._id, attachment,),
        );
      },);
      return Promise.all(attachmentPromises,);
    },
    removeLogisticOperatorAttachment ({ getters, }, idToRemove,) {
      return _api.removeAttachment(getters.actual._id, idToRemove,);
    },
  },
};
